import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {AppContext} from "../../../../app-context";
import {ConnectionType, DataType, TimeResolution} from "@flowmaps-com/flowmaps-typescriptmodels";
import {checkValidity} from "../../../../common/utils";
import {ComparatorChain} from "../../../../common/comparator-chain";
import {DateFieldRange} from "../../../../common/date/date-range/date-field-range";
import {DashboardContext} from "../../../dashboard/dashboard.context";
import {AppCommonUtils} from "../../../../common/app-common-utils";
import {downloadRawConnectionData} from "../connections-overview/connections-overview.component";

@Component({
  selector: 'app-connection-selection',
  templateUrl: './connection-selection.component.html',
  styleUrls: ['./connection-selection.component.scss']
})
export class ConnectionSelectionComponent {
    dashboardContext = DashboardContext;
    appContext = AppContext;

    @Input() comparator: ComparatorChain;
    @Input() selectedItems: any[] = [];
    @Input() sheetTemplate: any;
    @Input() csvMapper: (csv: string) => any[];
    @Input() onDownloaded: () => void;
    @Input() cancelMethod: () => void;
    @Input() optionalDataTypes: DataType[] = [];

    defaultDownloadRange = DashboardContext.defaultRange;

    resolution: TimeResolution = TimeResolution.hour;
    timeRange: DateFieldRange = this.defaultDownloadRange();
    @ViewChild("downloadDataBar") downloadDataBar: ElementRef;

    get supportedResolutions(): TimeResolution[] {
        const hasElectricity = this.selectedItems.some(item =>
            item.connection?.info?.connectionType === ConnectionType.Electricity);
        return AppContext.supportedResolutions.filter(resolution =>
            resolution !== TimeResolution.minute || hasElectricity);
    }

    downloadData = () => {
        if (checkValidity(this.downloadDataBar.nativeElement)) {
            if (this.selectedItems.length === 0) {
                AppCommonUtils.registerError("Please select at least 1 record");
                return;
            }
            downloadRawConnectionData(this.timeRange, this.resolution, this.selectedItems, this.optionalDataTypes, this.csvMapper, this.comparator, this.onDownloaded);
        }
    }
}
